// services/authService.js
import axios from "axios";
import config from "../config";

// Create axios instance for auth endpoints
const authApi = axios.create({
  baseURL: config.backend_Url,
  headers: {
    'Accept': 'application/json',
  },
});

// Send reset password email
export const sendResetEmail = async (email) => {
  try {
    // console.log('📧 Sending reset email to:', email);
    // console.log('📧 Request query params:', { email: email });
    // console.log('📧 Request URL:', `${authApi.defaults.baseURL}/users/forgot-password?email=${encodeURIComponent(email)}`);
    
    const response = await authApi.post(
      '/users/forgot-password',
      null, // no body
      { params: { email } } // => /users/forgot-password?email=...
    );
    // console.log('📦 Raw response from sendResetEmail:', response.data);
    return { ok: true, data: response.data };
  } catch (error) {
    console.error('Error sending reset email:', error);
    if (error.response) {
      // Server responded with error status
      // console.log('📦 Error status:', error.response.status);
      // console.log('📦 Error response headers:', error.response.headers);
      // console.log('📦 Error response data:', error.response.data);
      // console.log('📦 Error response config:', error.response.config);
      
      return { 
        ok: false, 
        error: error.response.data || error.response.statusText,
        status: error.response.status
      };
    } else if (error.request) {
      // Request was made but no response received
      // console.log('📦 No response received:', error.request);
      return { 
        ok: false, 
        error: 'Network error - please check your connection' 
      };
    } else {
      // Something else happened
      // console.log('📦 Request setup error:', error.message);
      return { 
        ok: false, 
        error: error.message || 'An unexpected error occurred' 
      };
    }
  }
};

// Verify OTP
export const verifyOtp = async (email, code) => {
  try {
    // console.log('🔐 Verifying OTP for:', email, 'otp:', code);
    const response = await authApi.post('/users/check-otp', null, {
      params: { email, otp: code },
    });

    // console.log('📦 OTP verification response:', response.data);

    const resData = response.data || {};

    // token may be nested at resData.data.reset_token (your screenshot),
    // or at resData.reset_token / resData.data.token etc. Try all.
    const maybeToken =
      (resData.data && (resData.data.reset_token || resData.data.token)) ||
      resData.reset_token ||
      resData.token ||
      null;

    return {
      ok: !!resData.success,
      data: resData,
      reset_token: maybeToken,
      message: resData.message || null,
      status: response.status,
    };
  } catch (error) {
    // console.error('Error verifying OTP:', error);
    if (error.response) {
      return {
        ok: false,
        error: error.response.data?.message || error.response.data || error.response.statusText,
        status: error.response.status,
      };
    } else if (error.request) {
      return { ok: false, error: 'Network error - please check your connection' };
    }
    return { ok: false, error: error.message || 'An unexpected error occurred' };
  }
};

// Reset password
export const resetPassword = async (email, newPassword, resetToken) => {
  try {
    // console.log('🔑 Resetting password for:', email);
    // console.log('🔑 Reset token:', resetToken);
    // console.log('🔑 Request URL:', `${authApi.defaults.baseURL}/users/reset-password?email=${encodeURIComponent(email)}&new_password=${encodeURIComponent(newPassword)}&reset_token=${encodeURIComponent(resetToken)}`);
    
    const response = await authApi.post(
      '/users/reset-password',
      null, // no body
      { 
        params: { 
          email: email,
          new_password: newPassword,
          reset_token: resetToken
        } 
      }
    );
    
    // console.log('📦 Password reset response:', response.data);
    
    if (response.data.success) {
      return { 
        ok: true, 
        data: response.data 
      };
    } else {
      return { 
        ok: false, 
        error: response.data.message || 'Failed to reset password',
        status: response.status 
      };
    }
  } catch (error) {
    console.error('Error resetting password:', error);
    if (error.response) {
      // console.log('📦 Reset Error status:', error.response.status);
      // console.log('📦 Reset Error response data:', error.response.data);
      
      return { 
        ok: false, 
        error: error.response.data?.message || error.response.data || error.response.statusText,
        status: error.response.status
      };
    } else if (error.request) {
      return { 
        ok: false, 
        error: 'Network error - please check your connection' 
      };
    } else {
      return { 
        ok: false, 
        error: error.message || 'An unexpected error occurred' 
      };
    }
  }
};
